// extracted by mini-css-extract-plugin
module.exports = {"checkoutSpinner":"yM","active":"zM","checkoutSection":"AM","noBorder":"BM","sectionOverlay":"CM"};